import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';

const DentalCriteria2 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingStore: { productLines, cart, setCurrentProductLineId },
    browsingFilterStore: { browsingCriteria, onBrowsingCriteriaChange, getBrowsingCriteriaValue },
    browsingCriteriaModalStore: { openBrowsingCriteriaModal },
  } = useRootStore();

  const convertedProductLines = productLines.map((line) => toJS(line)).slice();
  const convertedCart = toJS(cart);
  const convertedBc = toJS(browsingCriteria);

  const bcName = 'ortho';

  const openBcModal = (): void => {
    const selectedProductLineId = 'GroupDental';

    setCurrentProductLineId(selectedProductLineId);
    const pLine = convertedProductLines.find((line) => line.productLineId === selectedProductLineId);
    void openBrowsingCriteriaModal(
      convertedCart,
      selectedProductLineId,
      pLine?.eStoreBcFormId || pLine?.bcFormId || '',
      convertedBc,
    );
  };

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'ortho-yes',
      label: 'Yes',
      value: 'true',
    },
    {
      id: 'ortho-no',
      label: 'No',
      value: 'false',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Orthodontics"
        subtitle="If the company has five or more enrolled employees, it may choose to include orthodontic coverage for adults and children. This option is available for Choice, UltraSavings, Passive and Enhanced Plans."
      />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
          if (e.target.value === 'false') {
            openBcModal();
          }
        }}
      />
    </div>
  );
});

export default withCriteria(DentalCriteria2, 2);
